import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.edit
const { onChangeField } = rootActions.companies.oneCompany

function* editSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/companies/${payload.id}`, { ...payload.data })
        if (response.success) {
            yield put(onSuccess(response.result))
            yield put(onChangeField(payload.data))
            if (payload.sagaCB) {
                yield payload.sagaCB?.onSuccess(response.result)
            }
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editSagaTask)
}

export default editSaga
